<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-2">
      <p v-show="label" class="text-subtitle-1 mb-2" v-text="label" />
      <slot name="button" />
    </div>
    <v-textarea
      ref="baseInput"
      v-bind="$attrs"
      auto-grow
      class="base-text-area"
      filled
      v-on="$listeners"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseTextArea',
  props: {
    label: {
      type: String,
      default: '',
    },
  },
}
</script>

<style>
.base-text-area .v-input__slot {
  background: #f8f8f8 !important;
}
</style>
